import { Component, Input, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import './swiper-element-init';
import { AppService } from 'src/app/services';

@Component({
  selector: 'app-full-screen-media',
  templateUrl: './full-screen-media.component.html',
  styleUrls: ['./full-screen-media.component.scss'],
})
export class FullScreenMediaComponent implements OnInit, AfterViewInit {

  public currentIndex: any = 0;
  public isMobile: boolean;
  public sliderOpts = {
    initialSlide: 0,
    zoom: {
      maxRatio: 4
    }
  };

  @ViewChild('swiper', { static: false }) swiperRef: ElementRef;

  @Input() images: Array<object> = [];
  @Input() attachmentUrl: string;
  @Input() type: "image" | "video" = "image";
  @Input() index = 0;

  constructor(
    private appService: AppService,
    private modalCtrl: ModalController,
  ) { }

  ngOnInit() {
    this.isMobile = this.appService.isMobile();
    if (this.type === 'video') {
      this.pauseInlineVideos();
    }
    this.sliderOpts.initialSlide = this.index;
    this.currentIndex = this.index;
    setTimeout(() => {
      const swiperEl = this.swiperRef?.nativeElement;
      if (swiperEl && swiperEl.swiper) {
        swiperEl.swiper.slideTo(this.currentIndex, 0);
      }
    }, 0);
  }


  previousImage() {
    if (this.currentIndex > 0) {
      this.currentIndex -= 1;
      const swiperEl = this.swiperRef?.nativeElement;
      if (swiperEl && swiperEl.swiper) {
        swiperEl.swiper.slideTo(this.currentIndex);
      }
    }
  }


  nextImage() {
    if (this.currentIndex < this.images.length - 1) {
      this.currentIndex += 1;
      const swiperEl = this.swiperRef?.nativeElement;
      if (swiperEl && swiperEl.swiper) {
        swiperEl.swiper.slideTo(this.currentIndex);
      }
    }
  }


  slideChanged(event: any) {
    const swiperEl = this.swiperRef?.nativeElement;
    if (swiperEl && swiperEl.swiper) {
      this.currentIndex = swiperEl.swiper.activeIndex;
    }
  }
  ngAfterViewInit() {
    // Optionally, you can access the swiper instance here if needed
  }

  close() {
    this.modalCtrl.dismiss();
  }

  /** Stop any inline players still running behind the fullscreen modal. */
  private pauseInlineVideos(): void {
    document.querySelectorAll('video').forEach((video) => {
      if (!video.paused) {
        video.pause();
      }
    });
  }
}
